import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import moment from 'moment';
import constClass from '../../Constants/Constants';

const PointHistory = ({ siteId, liffAccessToken, mallId }) => {
  const [historyData, setHistoryData] = useState(null);
  const refreshData = useCallback(async () => {
    try {
      //各データ取得APIを先に実行
      const history = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/points/line/history/`, { site_id: siteId, line_id: liffAccessToken, mall_id: mallId })).data;
      const merged = [];
      const seen = new Set();

      history.data.forEach(item => {
        if (item.point_type === 4) {
          const dateKey = moment(item.history_date).format('YYYY-MM-DD');
          if (!seen[dateKey]) {
            seen[dateKey] = { ...item, point: Number(item.point) };
            merged.push(seen[dateKey]);
          } else {
            seen[dateKey].point += Number(item.point);
          }
        } else if (item.point_type !== undefined && item.point_type !== null && Number(item.point_type) === Number(constClass.POINT_TYPE.NIMOCLE) && item.point_uuid) {
          // nimocleポイントは1回の付与がランク対象分/施設固定倍率上乗せ分/キャンペーン倍率上乗せ分の
          // 最大3レコードに分かれてt_pointsへ登録される（nnr-mall-backend側の仕様）。
          // 画面上は付与対象月＋施設単位で1行にまとめる。
          // point_uuidは`${use_ym}-${mall_id}-${line_id}`形式なので先頭から付与対象月を取り出す。
          const useYm = String(item.point_uuid).split('-')[0];
          const nimocleKey = `nimocle-${useYm}-${item.mall_id}`;
          if (!seen[nimocleKey]) {
            const ymLabel = /^\d{6}$/.test(useYm) ? `${useYm.slice(0, 4)}年${Number(useYm.slice(4, 6))}月分` : null;
            seen[nimocleKey] = { ...item, point: Number(item.point), amount: Number(item.amount) || 0, is_nimocle: true, nimocle_ym: useYm, nimocle_ym_label: ymLabel };
            merged.push(seen[nimocleKey]);
          } else {
            seen[nimocleKey].point += Number(item.point);
            if (Number(item.amount) > seen[nimocleKey].amount) {
              seen[nimocleKey].amount = Number(item.amount);
            }
          }
        } else {
          merged.push(item);
        }
      });
      // 同じ月分のnimocleポイントは施設ごとの付与処理の完了順（ミリ秒差）で並んでしまうため、
      // 連続している同月分の範囲だけ施設ID(mall_id)の小さい順に並べ替える
      for (let start = 0; start < merged.length; start++) {
        if (!merged[start].is_nimocle) continue;
        let end = start + 1;
        while (end < merged.length && merged[end].is_nimocle && merged[end].nimocle_ym === merged[start].nimocle_ym) end++;
        const sorted = merged.slice(start, end).sort((a, b) => Number(a.mall_id) - Number(b.mall_id));
        merged.splice(start, sorted.length, ...sorted);
        start = end - 1;
      }
      const filterHistory = merged.filter(item => item.ticket_type !== constClass.FLAG.OFF && item.point >= 0);
      setHistoryData(filterHistory);
    } catch (err) {
      console.log(err);
    }
  }, [siteId, liffAccessToken, mallId]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  return (
    <div id="membershippass" className="point-history">
      <div className='point-history-text'>
        ポイント履歴
      </div>
      <div className='frame94'>
        <div className='frame92'>
          <div className='frame81'>
            <div className='point-date'>日付</div>
          </div>
          <div className='frame79'>
            <div className='frame77'>
              <div className='point-detail'>内容</div>
              <div className='point-use-shop'>ご利用店舗</div>
            </div>
          </div>
          <div className='frame80'>
            <div className='point-text'>ポイント</div>
          </div>
        </div>
        {historyData && historyData.length > 0 ?
          historyData.map((item, index) => (
            <React.Fragment key={index}>
              <div className='frame93'>
                <div className='frame79'>
                  <div className='frame81'>
                    <div className='point-date-text'>{moment(item.history_date).format('YYYY/MM/DD')}</div>
                  </div>
                  <div className='frame79'>
                    {item.is_nimocle ? (
                      // style.cssの.point-detail-text/.point-use-shop-textは高さ8px固定で複数行だと重なるため、
                      // nimocle行は高さを自動にして「ボーナスポイント／対象月／施設名」を縦に並べる
                      // 日付・ポイント・他の履歴行の文字は高さ固定(8〜10px)からline-height(14.32px)分下にはみ出して
                      // 描画され見た目が約5px下寄りになっているため、上に同じだけ余白を足して位置を揃える
                      <div className='frame77' style={{ gap: 0, paddingTop: '5px' }}>
                        <div className='point-detail-text' style={{ height: 'auto' }}>
                          <div>nimocleボーナスポイント</div>
                          {item.nimocle_ym_label && <div>（{item.nimocle_ym_label}）</div>}
                        </div>
                        <div className='point-use-shop-text' style={{ height: 'auto' }}>{item.mall_name ? item.mall_name : ""}</div>
                      </div>
                    ) : (
                    <div className='frame77'>
                      <div className='point-detail-text'>
                        {item.remarks && <div className=''> {item.remarks}</div>}
                        {item.returns_type ? (
                          <div className=''>
                            {moment(item.point_date).format('YYYY/MM/DD')} {constClass.RETURNS_TYPE_NAME[item.returns_type]}
                          </div>
                        ) : (item.use_point || item.expire_point) ? (
                          ""
                        ) : (item.point_type && item.point_type.toString() === constClass.POINT_TYPE.FIRST.toString()) ? (
                          <div className=''>初回登録特典</div>
                        ) : item.point_type === 4 ? (
                          <div className=''>ランクアップポイント</div>
                        ) : (
                          <div className=''>
                            ポイント付与{Number(item.amount) > 0 && `(${item.amount.toLocaleString()}円)`}
                          </div>
                        )}
                      </div>
                      {item.point_type !== 4 &&
                        <div className='point-use-shop-text'>{item.shop_name ? item.shop_name : ""}{item.mall_name ? `(${item.mall_name})` : ""}</div>
                      }
                    </div>
                    )}
                  </div>
                  <div className='frame80'>
                    <div className={item.expire_point ? 'point-minus-value-text' : item.use_point ? 'point-minus-value-text' : 'point-plus-value-text'}>
                      {item.expire_point ? <><span>-  {item.expire_point.toLocaleString()}</span> <span className='pt-minus-text'>pt</span></> : item.use_point ? <><span>-  {item.use_point.toLocaleString()}</span> <span className='pt-minus-text'>pt</span></> : item.point ? <><span>+  {item.point.toLocaleString()}</span> <span className='pt-plus-text'>pt</span></> : "-"}
                    </div>
                  </div>
                </div>
              </div>
              <div className='vector17'></div>
            </React.Fragment>
          )) : <div colSpan={3} className='p-2 text-center mt-4'>履歴がありませんでした</div>}
      </div>
    </div>
  );
};

export default PointHistory;